import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53585cb4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-title" }, "Новости", -1))
const _hoisted_3 = {
  key: 0,
  class: "news-list"
}
const _hoisted_4 = { class: "date" }
const _hoisted_5 = { class: "title" }

import { ref, onMounted } from 'vue'
  import axios from 'axios'
  import moment from 'moment'
  import NewsPreloader from './NewsPreloader.vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'News',
  setup(__props) {

// @ts-nocheck
  onMounted(async()=> {
    await getNews()
  })

  const news = ref([])
  const newsPaginator = ref(1)

  const uploadsEnv = process.env.VUE_APP_STRAPI_UPLOADS

  const getNews = async () => {
    const req = await axios.get(`${process.env.VUE_APP_STRAPI_API}/news?populate=preview,documents&pagination[pageSize]=100&pagination[page]=${newsPaginator.value}`)
    // const req = await axios.get(`https://admin.roecocity.ru/api/news?populate=preview,documents&pagination[pageSize]=100&pagination[page]=${newsPaginator.value}`)

    req.data.data.forEach(item => {
      news.value.push({
        id: item.id,
        title: item.attributes.title ? item.attributes.title : '',
        preview:  item.attributes.preview?.data ? `${uploadsEnv}${item.attributes.preview.data[0].attributes.url}` : require('@/assets/images/no-article-preview.svg'),
        date: item.attributes.userdate ? parseInt((new Date(item.attributes.userdate).getTime() / 1000).toFixed(0)) : parseInt((new Date(item.attributes.publishedAt).getTime() / 1000).toFixed(0)),
      })
    })

    if(req.data.data.length){
      newsPaginator.value++
      getNews()
    } else {
      const compareDates = (a, b) =>  a.date - b.date
      news.value.sort(compareDates).reverse()
    }
  }

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_Transition, { name: "quick-hide" }, {
      default: _withCtx(() => [
        (!news.value.length)
          ? (_openBlock(), _createBlock(NewsPreloader, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "quick-hide" }, {
      default: _withCtx(() => [
        (news.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(news.value, (article) => {
                return (_openBlock(), _createBlock(_component_router_link, {
                  key: article.id,
                  to: `/news/${article.id}`,
                  class: "news-item"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "preview",
                      style: _normalizeStyle({backgroundImage: `url(${article.preview}`})
                    }, null, 4),
                    _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(moment).unix(article.date).format('DD.MM.YYYY')), 1),
                    _createElementVNode("div", _hoisted_5, _toDisplayString(article.title), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})